export const SAVEDINPUTS = "SAVEDINPUTS";
export const savedInputsAction = (data) => {
    return {
        type: SAVEDINPUTS,
        payload:data
    }
}